import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
// import storageSession from "redux-persist/lib/storage/session";
import storageSession from "redux-persist/lib/storage"; 
import rootReducer from "./RootReducer";

const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: ['loginInfo'],
};

const appReducer = (state, action) => {
  if (action.type === "SIGNOUT" ) {
    storageSession.removeItem("persist:root");
    return rootReducer(undefined, action); 
  }
  return rootReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, appReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export const persistor = persistStore(store);
